import type { InstagramCreator } from '@frontend/gql/social/graphql';
import { useDemographicsProps } from '@/shadcn/components/demographics/hooks/useDemographics';
import { InstagramDemographicsAdapter } from '@/applications/Social/creator-search/instagram/adapters/instagram-demographics-adapter';

// Factory for creating Instagram-specific hook
export const useInstagramDemographicsProps = (
  creator: InstagramCreator | null | undefined,
  isLoading: boolean,
  defaultTab: string = 'age',
  layout: 'side-by-side' | 'stacked' = 'side-by-side',
) => {
  const adapter = new InstagramDemographicsAdapter();
  return useDemographicsProps(creator, adapter, isLoading, defaultTab, layout);
};
